import React, { useEffect, useCallback, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classnames from 'classnames/bind';
import styles from './ProjectSelection.scss';
import { Button } from '@miroculus/nucleo';
import { selectProject, loadProjects } from 'reduxModules/experiment';
import { releaseDevice } from 'reduxModules/devices';
import { spinner } from 'images';

const cx = classnames.bind(styles);

export function ProjectSelection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const projects = useSelector((state) => state.experiment.projects);
  const loading = useSelector((state) => state.experiment.loadingProjects);

  const handleBackButtonClick = useCallback(() => {
    dispatch(releaseDevice());
    navigate(-1);
  }, [dispatch, navigate]);

  const handleProjectSelection = useCallback(
    (projectId) => {
      dispatch(selectProject(projectId));
    },
    [dispatch]
  );

  const handleMount = useCallback(() => {
    dispatch(loadProjects());
  }, [dispatch]);

  useEffect(() => {
    handleMount();
  }, [handleMount]);

  useEffect(() => {
    let timeout;
    if (!loading && projects?.length === 0) {
      // We wait a sensible amount of time to prevent race conditions in the
      // messages that we send to the device
      timeout = setTimeout(() => {
        handleProjectSelection(null);
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [loading, projects, handleProjectSelection]);

  return (
    <div className={cx('container')}>
      {loading || !projects || projects.length === 0 ? (
        <div className={cx('spinnerContainer')}>
          <img src={spinner} alt="logo" height={50} width={50} />
        </div>
      ) : (
        <>
          <div className={cx('titleContainer')}>
            <h2>Select your project</h2>
          </div>
          <div className={cx('projectsContainer')}>
            {projects.map((project) => (
              <div
                className={cx('project')}
                onClick={() => handleProjectSelection(project.id)}
                key={project.id}
              >
                {project.name}
              </div>
            ))}
          </div>
          <div className={cx('footer')}>
            <div className={cx('cancelButton')}>
              <Button onClick={handleBackButtonClick}>Cancel</Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default memo(ProjectSelection);
